module.exports = __webpack_public_path__ + "static/media/al.961951c7.svg";